import Caption from "../components/caption";

class Header {
  constructor() {
    this.menuInit();
    this.hamburger();
    this.stickyHeader();
    new Caption("js-error-image-caption");
  }

  hamburger = () => {
    const hamburger = document.querySelector(".js-header-hamburger");
    const header = document.querySelector(".js-header");
    const nav = document.querySelector(".js-navigation");
    hamburger.addEventListener("click", () => {
      header.classList.toggle("active");
      hamburger.classList.toggle("open");
      nav.classList.toggle("open");
      document.body.classList.toggle("stop-scroll");
    });
  };

  menuInit = () => {
    const menuItems = document.querySelectorAll(".js-menu-item");
    const header = document.querySelector(".js-header");
    const subMenuClose = document.querySelectorAll(".js-menu-return");
    const nav = document.querySelector(".js-navigation");

    subMenuClose.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        item.parentNode.classList.remove("open");
        nav.classList.remove("open-sub");
        nav.scrollTop = 0;
      });
    });
    menuItems.forEach((item) => {
      const submenu = item.querySelector(".js-submenu");
      const link = item.querySelector(".js-menu-item-link");
      item.addEventListener("mouseenter", () => {
        if (window.innerWidth > 1024) {
          submenu.classList.add("open");
          link.classList.add("active");
          header.classList.add("active");
        }
      });
      item.addEventListener("mouseleave", () => {
        if (window.innerWidth > 1024) {
          submenu.classList.remove("open");
          link.classList.remove("active");
          header.classList.remove("active");
        }
      });
      link.addEventListener("click", (e) => {
        if (window.innerWidth < 1025) {
          if (submenu) {
            e.preventDefault();
            e.stopPropagation();
            submenu.classList.add("open");
            nav.classList.add("open-sub");
            nav.scrollTop = 0;
          }
        }
      });
    });
  };
  stickyHeader = () => {
    const header = document.querySelector(".js-header");
    let prevPosY = window.scrollY;
    if (window.scrollY > 10) {
      header.classList.add("not-top");
    }

    addEventListener("scroll", () => {
      const posY = window.scrollY;
      if (posY < 10) {
        header.classList.remove("not-top");
      } else {
        header.classList.add("not-top");
      }
      prevPosY = posY;
    });
  };
}

new Header();
